const cards = [
  {
    tag: '日漫新番',
    title: '2026 夏季日漫追番推荐',
    desc: '精选本季最值得追的 20 部日漫新番，从热血少年到治愈日常，51动漫官网全部支持在线观看和免费下载。',
    img: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20collage%20in%20warm%20summer%20color%20palette%20with%20various%20anime%20character%20silhouettes%20and%20festival%20elements%20orange%20and%20gold%20tones%20soft%20artistic%20rendering%20clean%20composition&width=480&height=320&seq=guide-card-01&orientation=landscape',
  },
  {
    tag: '国漫精品',
    title: '2026 年必看国漫人气榜单',
    desc: '盘点年度口碑最佳的国漫作品，斗罗大陆、完美世界等 IP 大作持续更新，51动漫官网同步追番。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20fantasy%20landscape%20with%20traditional%20architecture%20and%20martial%20arts%20elements%20warm%20golden%20and%20red%20color%20palette%20ethereal%20atmosphere%20soft%20cinematic%20lighting%20clean%20composition&width=480&height=320&seq=guide-card-02&orientation=landscape',
  },
  {
    tag: '韩漫频道',
    title: '超人气韩漫追击 — 下拉式完美适配',
    desc: '我独自升级、全知读者视角等热门韩漫在51动漫官网火热连载中，下拉式阅读沉浸体验，免费下载离线追。',
    img: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20with%20modern%20urban%20setting%20and%20stylish%20characters%20warm%20peach%20and%20coral%20color%20palette%20soft%20atmospheric%20lighting%20clean%20composition&width=480&height=320&seq=guide-card-03&orientation=landscape',
  },
  {
    tag: '动漫电影',
    title: '动漫电影限时收录 — 大银幕佳作荟萃',
    desc: '收藏历年经典动漫电影，从新海诚到宫崎骏，51动漫官网收录多部高分动漫电影，高清画质在线观看。',
    img: 'https://readdy.ai/api/search-image?query=Anime%20movie%20style%20cinematic%20scene%20with%20dramatic%20sky%20and%20silhouetted%20figures%20warm%20sunset%20color%20palette%20with%20orange%20and%20pink%20hues%20emotive%20atmosphere%20soft%20lighting%20clean%20composition&width=480&height=320&seq=guide-card-04&orientation=landscape',
  },
  {
    tag: '追番指南',
    title: '新入坑漫友必读 — 51动漫追番全攻略',
    desc: '从日漫到国漫到韩漫，帮你快速找到适合自己的动漫类型。51动漫官网覆盖八大类型，总有一部适合你。',
    img: 'https://readdy.ai/api/search-image?query=Colorful%20anime%20style%20illustration%20with%20multiple%20genre%20icons%20action%20romance%20fantasy%20comedy%20arranged%20in%20a%20circular%20composition%20warm%20vibrant%20color%20palette%20playful%20atmosphere%20soft%20lighting%20clean%20background&width=480&height=320&seq=guide-card-05&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100/70">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-4">
          追番指南
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-[480px] mx-auto">
          根据你的喜好找到最适合的动漫追番路线
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((item, i) => (
            <div
              key={i}
              className={`bg-background-50 rounded-xl overflow-hidden hover:bg-background-50 transition-colors duration-200 cursor-pointer ${
                i === 3 || i === 4 ? 'lg:col-span-1' : ''
              } ${i === 3 ? 'lg:col-start-1' : ''} ${i === 4 ? 'lg:col-start-3' : ''}`}
            >
              <div className="relative aspect-video bg-background-200 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
                <span className="absolute top-3 left-3 text-xs font-medium bg-background-50/90 text-primary-600 px-2.5 py-1 rounded-full">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm font-semibold text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}